import React from "react";
import { Skeleton } from "../ui/skeleton";

const OrderSummarySkeleton = () => {
  return (
   <>
    <div className="border-b border-gray18 pb-[5px] pt-[15px]">
      <div className="text-sm pb-[10px] flex justify-between items-center	">
        <Skeleton className=" w-[94px] inline-block h-[20px]" />
        <Skeleton className=" w-[68px] inline-block h-[20px]" />
      </div>
      <div className="text-sm pb-[10px] flex justify-between items-center	">
        <Skeleton className=" w-[56px] inline-block h-[20px]" />
        <Skeleton className=" w-[78px] inline-block h-[20px]" />
      </div>

      <div className="text-sm pb-[10px] flex justify-between items-center	">
        <Skeleton className=" w-[120px] inline-block h-[20px]" />
        <Skeleton className=" w-[49px] inline-block h-[20px]" />
      </div>

      <div className="text-sm pb-[10px] flex justify-between items-center	">
        <Skeleton className=" w-[24px] inline-block h-[20px]" />
        <Skeleton className=" w-[55px] inline-block h-[20px]" />
      </div>

      <div className="text-sm flex justify-between items-center py-4 border-t border-gray18 	">
        <Skeleton className=" w-[35px] inline-block h-[20px]" />
        <Skeleton className=" w-[67px] inline-block h-[20px]" />
      </div>
    </div>
    
                {/* <div className="text-sm my-4 flex justify-between items-center	">
                  <Skeleton className=" w-[94px] inline-block h-[20px]" />
                  <Skeleton className=" w-[100px] inline-block h-[20px]" />
                </div> */}

            
   </>
  );
};

export default OrderSummarySkeleton;
